import React from "react";
import "./NavBarLogo.scss";

const NavBarLogo = () => (
  <svg viewBox="0 0 564 173" className="nav-bar-logo">
    <defs>
      <path id="a" d="M0 .892h170.745V155H0z" />
      <path id="c" d="M.627.415h23.54v15.328H.627z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fill="#FFF" fillRule="nonzero">
        <path d="M288.187 20.155l18.186 10.5v21l-18.186 10.5L270 51.655v-21zM340.187 20.155l18.186 10.5v21l-18.186 10.5L322 51.655v-21zM235.187 69.155l18.186 10.5v21l-18.186 10.5-18.187-10.5v-21zM288.187 69.155l18.186 10.5v21l-18.186 10.5-18.187-10.5v-21zM340.187 69.155l18.186 10.5v21l-18.186 10.5-18.187-10.5v-21zM235.187 119.155l18.186 10.5v21l-18.186 10.5-18.187-10.5v-21zM288.187 119.155l18.186 10.5v21l-18.186 10.5-18.187-10.5v-21zM340.187 119.155l18.186 10.5v21l-18.186 10.5-18.187-10.5v-21z" />
      </g>

      <g id="wrenchAndTarget">
        <g transform="rotate(2 -128.305 1743.409)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            d="M146.457 18.094l23.184-10.028s-12.427-10.74-37.048-4.534c0 0-16.253 40.104-29.159 51.563L6.632 129.574s-4.305 6.208-3.586 10.983c.716 4.772 6.93 11.935 13.624 11.458 6.692-.478 8.843-4.537 11.473-6.446 2.63-1.91 92.5-76.39 92.5-76.39a74.953 74.953 0 0 1 11.621-3.73c9.629-2.24 18.106-2.19 24.354-1.596.864.024 1.968-.037 3.212-.329a12.78 12.78 0 0 0 4.407-1.975l-17.78-43.455"
            fill="#D7DBE3"
            mask="url(#b)"
          />
        </g>
        <g transform="rotate(2 -1498.329 6361.396)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            d="M.627 9.3l2.67 6.443S18.37 8.784 24.167.415L.627 9.301z"
            fill="#D7DBE3"
            mask="url(#d)"
          />
        </g>
        <path
          id="wrenchTarget"
          fill="#58B5FF"
          fillRule="nonzero"
          d="M213.839 46.794l4.007-20.614 19.856-6.837L253.55 33.12l-4.007 20.614-19.856 6.837z"
        />
      </g>
    </g>
  </svg>
);

export default NavBarLogo;
